import theme from "Styles/theme";
import * as THREE from "three";

const CAMERA_SCALE = 0.4;
const CAMERA_ZOOM_MAX = theme.size.zoom.max;
const CAMERA_ZOOM_MIN = theme.size.zoom.min;
let nowZoom = 0;
let preZoom = 0;
let zoomActionUp = false;
let zoomActionDown = false;
let zoomActionChange = false;
let zoomChangeValue = 0;
let cameraChangeAction = setTimeout(() => {});

export const renderCamera = (zoom: number) => {
	const camera = new THREE.OrthographicCamera(
		(window.innerWidth / CAMERA_SCALE) * -1,
		window.innerWidth / CAMERA_SCALE,
		window.innerHeight / CAMERA_SCALE,
		(window.innerHeight / CAMERA_SCALE) * -1,
		1,
		5000
	);

	camera.zoom = zoom;
	camera.position.z = 1000;

	camera.updateProjectionMatrix();
	return camera;
};

export const cameraResize = (camera: any) => {
	camera.left = (window.innerWidth / CAMERA_SCALE) * -1;
	camera.right = window.innerWidth / CAMERA_SCALE;
	camera.top = window.innerHeight / CAMERA_SCALE;
	camera.bottom = (window.innerHeight / CAMERA_SCALE) * -1;
	camera.updateProjectionMatrix();
};

export const cameraAnimation = (camera: any, setZoomValue: any) => {
	preZoom = nowZoom;
	nowZoom = camera.zoom;

	if (nowZoom !== preZoom) {
		clearTimeout(cameraChangeAction);
		cameraChangeAction = setTimeout(() => {
			const value = +nowZoom.toFixed(1);
			setZoomValue(value);
		}, 100);
	}

	if (zoomActionUp) {
		zoomActionUp = false;
		camera.zoom++;
		if (camera.zoom >= CAMERA_ZOOM_MAX) {
			camera.zoom = CAMERA_ZOOM_MAX;
		}
	} else if (zoomActionDown) {
		zoomActionDown = false;
		camera.zoom--;
		if (camera.zoom <= CAMERA_ZOOM_MIN) {
			camera.zoom = CAMERA_ZOOM_MIN;
		}
	} else if (zoomActionChange) {
		zoomActionChange = false;
		camera.zoom = zoomChangeValue;
	}

	camera.updateProjectionMatrix();
};

export const zoomUp = () => {
	zoomActionUp = true;
};
export const zoomDown = () => {
	zoomActionDown = true;
};
export const zoomChange = (value: number) => {
	zoomActionChange = true;
	zoomChangeValue = value;
};
